import { GoodsContainer } from "./Goods.styled";
import { observer } from "mobx-react";
import { useStores } from "../../../stores";
import { GoodItem } from "./GoodItem";
import { motion } from "framer-motion";
import { PricingActualPlans } from "../../../interfaces";
import { ShopGoodCart } from "../../../components/common";

interface GoodsProps {}

const listVariants = {
	hidden: { opacity: 0, y: 20 },
	visible: (i: number) => ({
		opacity: 1,
		y: 0,
		transition: {
			delay: i * 0.1,
			duration: 0.4,
			type: "spring",
		},
	}),
	exit: { opacity: 0, y: -10, transition: { duration: 0.2 } },
};

export const Goods = observer(({}: GoodsProps) => {
	const { pricingActualStore, shopGoodsStore } = useStores();

	return (
		<GoodsContainer>
			{shopGoodsStore.list.map((good, index) => {
				return (
					<motion.div
						key={`${good.id}`}
						custom={`${index}`}
						initial="hidden"
						animate="visible"
						exit="exit"
						variants={listVariants}
						layout // позволяет плавно адаптироваться к перестановкам
						style={{ display: "flex" }}
					>
						{pricingActualStore.plans === PricingActualPlans.SUBSCRIPTION_PLANS && (
							<GoodItem shopGoodStore={good} {...good} />
						)}

						{pricingActualStore.plans !== PricingActualPlans.SUBSCRIPTION_PLANS && (
							<ShopGoodCart shopGoodStore={good} />
						)}
					</motion.div>
				);
			})}
		</GoodsContainer>
	);
});
